import { authApiProvider, InitPasswordBody } from "@/providers/auth-api-provider";
import router from "../router/router";
import store from "../stores/store";
import { trackingApiProvider } from "@/providers/tracking-api-provider";

export default abstract class AuthHelper {
  private static async forceAuthReload(response: { access_token?: string }, route: string = null) {
    await this.launchApp(response.access_token);
    await trackingApiProvider.registerEvent({ type: "login" });

    if (route) {
      await router.replace(route).catch(() => {});
    } else {
      document.location.reload();
    }
  }

  public static async connection(body: { email: string; password: string }) {
    const response: { access_token?: string, status?: string, user_email?: string, user_id?: number } = await authApiProvider.connection(body);

    if (response != null && response.access_token) {
      await this.forceAuthReload(response);
    } else {
      return response;
    }
  }

  public static async twoFactorLogin(body: { code: number; user_id?: number, user_email?: string, status?: string }) {
    const response: { access_token?: string } = await authApiProvider.twoFactorLogin(body);

    if (response != null && response.access_token) {
      await this.forceAuthReload(response);
    }
  }

  public static async loginAs(userId: string) {
    const response: string = await authApiProvider.loginAs(userId);
    if (response != null) {
      await router.replace("/dashboard").catch(() => {});
      await this.launchAppImpersonate(response);
      document.location.reload();
    }
  }

  public static async revertImpersonate() {
    await store.commit("auth/setApiTokenImpersonate", null);
    await store.dispatch("user/fetchUser");
    await store.dispatch("attribute/fetchAllAttribute");
    await store.dispatch("productFamily/fetchAllFamilies");
    document.location.reload();
  }

  public static async initPassword(body: {
    password: string;
    password_confirmation: string;
    email: string | (string | null)[];
    token: string | (string | null)[];
  }) {
    const response: { access_token?: string } = await authApiProvider.setPassword(body);
    if (response && response.access_token) {
      await this.forceAuthReload(response, '/dashboard');
    } else if (response != null) {
      await router.replace("/login");
    }
  }

  public static async resetPassword(body: InitPasswordBody) {
    const response: { access_token?: string } = await authApiProvider.setPassword(body);
    if (response && response.access_token) {
      await this.forceAuthReload(response, '/dashboard');
    } else if (response != null) {
      await router.replace("/login");
    }
  }

  private static async launchApp(token: string) {
    await store.dispatch("reset");
    await store.commit("auth/setApiToken", token);
    await store.dispatch("user/fetchUser");
    await store.dispatch("attribute/fetchAllAttribute");
    await store.dispatch("productFamily/fetchAllFamilies");
  }

  private static async launchAppImpersonate(tokenImpersonate: string) {
    await store.commit("auth/setApiTokenImpersonate", tokenImpersonate);
    await store.dispatch("user/fetchUser");
    await store.dispatch("attribute/fetchAllAttribute");
    await store.dispatch("productFamily/fetchAllFamilies");
  }

  public static async logout() {
    await store.dispatch("reset");
    await router.replace("/login");
  }
}
